import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 2rem;
  text-align: left;
`;

const PageTitle = styled.h1`
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #005eb8;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1rem;
`;

const CookiePolicy = () => {
    return (
        <PageContainer>
            <PageTitle>Cookie Policy</PageTitle>
            <Section>
                <SectionTitle>About this cookie policy</SectionTitle>
                <Paragraph>
                    This Cookie Policy explains what cookies are and how we use them. You should read this policy to understand what cookies are, how we use them, the types of cookies we use i.e, the information we collect using cookies and how that information is used and how to control the cookie preferences.
                </Paragraph>
            </Section>
            <Section>
                <SectionTitle>What are cookies?</SectionTitle>
                <Paragraph>
                    Cookies are small text files that are used to store small pieces of information. The cookies are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, make the website more secure, provide better user experience, and understand how the website performs and to analyze what works and where it needs improvement.
                </Paragraph>
            </Section>
            <Section>
                <SectionTitle>How do we use cookies?</SectionTitle>
                <Paragraph>
                    As most of the online services, our website uses first-party and third-party cookies for a number of purposes. The first-party cookies are mostly necessary for the website to function the right way, and they do not collect any of your personally identifiable data.
                </Paragraph>
                <Paragraph>
                    The third-party cookies used on our websites are used mainly for understanding how the website performs, how you interact with our website, keeping our services secure, providing advertisements that are relevant to you, and all in all providing you with a better and improved user experience and help speed up your future interactions with our website.
                </Paragraph>
            </Section>
        </PageContainer>
    );
};

export default CookiePolicy;